const getFlowNetworkDisplayName = name => `Flow N/W: ${name}`;
const getStreamDisplayName = name => `Stream: ${name}`;
const getProducerDisplayName = name => `Producer: ${name}`;
const getConsumerDisplayName = name => `Consumer: ${name}`;
const getStreamCloneDisplayName = name => `Stream Clone: ${name}`;
const getNetworkDisplayName = name => `Network: ${name}`;
const getDeviceDisplayName = name => `Device: ${name}`;
const getPointDisplayName = name => `Point: ${name}`;

export const constructFlowNetworkNames = flowNetworks => {
  let nameMap = {};
  flowNetworks.forEach(network => {
    nameMap[network.uuid] = getFlowNetworkDisplayName(network.name);
    if (network.hasOwnProperty('streams')) {
      network.streams.forEach(stream => {
        nameMap[stream.uuid] = getStreamDisplayName(stream.name);
        if (stream.hasOwnProperty('producers')) {
          stream.producers.forEach(producer => {
            nameMap[producer.uuid] = getProducerDisplayName(producer.name);
          });
        }
      });
    }
  });
  return nameMap;
};

export const constructFlowNetworkCloneNames = (flowNetworkClones = []) => {
  let nameMap = {};
  flowNetworkClones.forEach(network => {
    nameMap[network.uuid] = getFlowNetworkDisplayName(network.name);
    if (network.hasOwnProperty('stream_clones')) {
      network.stream_clones.forEach(streamClone => {
        nameMap[streamClone.uuid] = getStreamCloneDisplayName(streamClone.name);
        if (streamClone.hasOwnProperty('consumers')) {
          streamClone.consumers.forEach(consumer => {
            nameMap[consumer.uuid] = getConsumerDisplayName(consumer.name);
          });
        }
      });
    }
  });
  return nameMap;
};

export const contructNetworkNames = networks => {
  let nameMap = {};
  networks.forEach(network => {
    nameMap[network.uuid] = getNetworkDisplayName(network.name);
    if (network.hasOwnProperty('devices')) {
      network.devices.forEach(device => {
        nameMap[device.uuid] = getDeviceDisplayName(device.name);
        if (device.hasOwnProperty('points')) {
          device.points.forEach(point => {
            nameMap[point.uuid] = getPointDisplayName(point.name);
          });
        }
      });
    }
  });
  return nameMap;
};
